import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import Button from "src/components/Button";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import useAuth from "src/hooks/selectors/useAuth";
import useModules from "src/hooks/selectors/useModules";

interface CreateTaskButtonProps extends Translation {
	variant?: "INTERN" | "EXTERN" | "CREATE";
	small?: boolean;
	iconOnly?: boolean;
}

const CreateTaskButton = ({
	t,
	variant,
	small,
	iconOnly,
}: CreateTaskButtonProps) => {
	const auth = useAuth();
	const { modules } = useModules();
	const location = useLocation();
	const to = useMemo(() => {
		const sp = new URLSearchParams(location.search);
		let url = auth.has_subscription ? "/tasks/create" : "/subscription";
		if (variant === "CREATE") {
			return url;
		}

		const forceModal = true;

		if (forceModal) {
			if (variant === "INTERN") {
				url = location.pathname;
				sp.set("modal", "create-intern-task");
			}
			if (variant === "EXTERN") {
				url = location.pathname;
				sp.set("modal", "create-extern-task");
			}
		}

		return `${url}${sp ? `?${sp.toString()}` : ""}`;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		auth.has_subscription,
		location.search,
		location.pathname,
		modules,
		variant,
	]);

	return (
		<Button
			{...{ to, small, iconOnly }}
			type={variant === "EXTERN" ? "gray" : "dark"}
		>
			{variant && ["INTERN", "CREATE"].includes(variant) && (
				<i className={`fas fa-plus ${!iconOnly && "mr-2"}`}></i>
			)}
			{variant === "EXTERN" && (
				<i
					className={`fas fa-hands-helping ${!iconOnly && "mr-2"}`}
				></i>
			)}
			{!iconOnly &&
				t(
					variant === "EXTERN"
						? "cta-extern"
						: variant === "CREATE"
						? "cta-create"
						: "cta-intern"
				)}
		</Button>
	);
};

CreateTaskButton.locale = {
	nl: {
		"cta-intern": "Taak maken",
		"cta-extern": "Taak uitbesteden",
		"cta-create": "Opdracht aanmaken",
	},
	en: {
		"cta-intern": "Create task",
		"cta-create": "Create task",
		"cta-extern": "Outsource task",
	},
};

export default withTranslation(CreateTaskButton);
